import React from 'react';

import {
  BankIcon,
  CalculatorIcon,
  ClockIcon,
  DateIcon,
  DollarIcon,
  WalletIcon,
  WarningIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { StatusColor, StatusEnum } from 'constants/status';
import { getConditionalArray } from 'utils/data';

import { formatCurrency, formatDateValue } from '../Servicing.utils';

const SUMMARY_CARDS_NAMES = {
  CURRENT_UPB: 'Current UPB',
  NEXT_PAYMENT_DUE: 'Next Payment Due',
  NEXT_PAYMENT_AMOUNT: 'Next Payment Amount',
  ESCROW_BALANCE: 'Escrow Balance',
  SUSPENSE_BALANCE: 'Suspense Balance',
  DAYS_DELINQUENT: 'Days Delinquent',
  PAYMENTS_RECEIVED: 'Payments Received',
  TOTAL_PAYMENTS: 'Total Payments',
  CREDIT_LIMIT: 'Credit Limit',
  AVAILABLE_CREDIT: 'Available Credit',
};

const getSharedCards = summary => [
  {
    name: SUMMARY_CARDS_NAMES.CURRENT_UPB,
    value: formatCurrency(summary?.currentUPB),
    icon: <DollarIcon />,
    iconColor: StatusColor[StatusEnum.INFO],
  },
  {
    name: SUMMARY_CARDS_NAMES.NEXT_PAYMENT_DUE,
    value: formatDateValue(summary?.nextPaymentDueDate),
    icon: <DateIcon />,
    iconColor: StatusColor[StatusEnum.SUCCESS],
  },
  {
    name: SUMMARY_CARDS_NAMES.NEXT_PAYMENT_AMOUNT,
    value: formatCurrency(summary?.nextPaymentAmount),
    icon: <WalletIcon />,
    iconColor: StatusColor[StatusEnum.INFO],
  },
];

const getSharedTrailingCards = summary => [
  {
    name: SUMMARY_CARDS_NAMES.DAYS_DELINQUENT,
    value: summary?.daysDelinquent ?? '-',
    icon: <WarningIcon />,
    iconColor: StatusColor[StatusEnum.ERROR],
  },
  {
    name: SUMMARY_CARDS_NAMES.PAYMENTS_RECEIVED,
    value: summary?.totalPaymentsReceived ?? '-',
    icon: <CalculatorIcon />,
    iconColor: StatusColor[StatusEnum.SUCCESS],
  },
  {
    name: SUMMARY_CARDS_NAMES.TOTAL_PAYMENTS,
    value: formatCurrency(summary?.totalPaymentsAmount),
    icon: <DollarIcon />,
    iconColor: StatusColor[StatusEnum.SUCCESS],
  },
];

export const getSummaryInfoConfig = (summary, { isHeloc, hasEscrow = false } = {}) => {
  if (isHeloc) {
    return [
      {
        name: SUMMARY_CARDS_NAMES.CREDIT_LIMIT,
        value: formatCurrency(summary?.creditLimit),
        icon: <BankIcon />,
        iconColor: StatusColor[StatusEnum.SUCCESS],
      },
      ...getSharedCards(summary),
      {
        name: SUMMARY_CARDS_NAMES.AVAILABLE_CREDIT,
        value: formatCurrency(summary?.availableCredit),
        icon: <WalletIcon />,
        iconColor: StatusColor[StatusEnum.SUCCESS],
      },
      ...getConditionalArray(hasEscrow, () => [
        {
          name: SUMMARY_CARDS_NAMES.ESCROW_BALANCE,
          value: formatCurrency(summary?.escrowBalance),
          icon: <BankIcon />,
          iconColor: StatusColor[StatusEnum.SUCCESS],
        },
      ]),
      ...getSharedTrailingCards(summary),
    ];
  }

  return [
    ...getSharedCards(summary),
    {
      name: SUMMARY_CARDS_NAMES.ESCROW_BALANCE,
      value: formatCurrency(summary?.escrowBalance),
      icon: <BankIcon />,
      iconColor: StatusColor[StatusEnum.SUCCESS],
    },
    {
      name: SUMMARY_CARDS_NAMES.SUSPENSE_BALANCE,
      value: formatCurrency(summary?.suspenseBalance),
      icon: <ClockIcon />,
      iconColor: StatusColor[StatusEnum.WARNING],
    },
    ...getSharedTrailingCards(summary),
  ];
};
